module.exports = __webpack_public_path__ + "img/ipoint-logo-450x225.302d2473.png";